ClubCourtsPolicyController.$inject = [
    '$scope',
    'CONST',
    '$uibModalInstance',
    'Time',
    '_',
    'court',
    'Club',
    'alerts',
    'User',
];

/* @ngInject */
function ClubCourtsPolicyController(
    $scope,
    CONST,
    $uibModalInstance,
    Time,
    _,
    court,
    Club,
    alerts,
    User,
) {
    var vm = this;
    vm.title = 'ClubCourtsPolicyController';
    vm.courtName = court.name;

    vm.cancellation_policy = court.cancellation_policy_id;
    vm.court = court;
    vm.court.cancellation_policy_id = court.cancellation_policy_id ?? 1

    vm.loading = true;
    vm.policies = [];

    /**
     * Actions
     */

    vm.save = function () {
        alerts.code(null, null, User).then(save);
    };
    vm.close = function () {
        $uibModalInstance.dismiss();
    };

    activate();
    ////////////////

    function activate() {
        Club.API.getList('policies').then(function (policies) {
            vm.policies = policies;
            // Courts parse:
            vm.loading = false;
        });
    }

    function save(code) {
        var data = {
            cancellation_policy_id: court.cancellation_policy_id,
            code: code,
        };

        vm.loading = true;
        return court.api
            .customPUT(data, '')
            .then(function () {
                court.cancellation_policy_id = data.cancellation_policy_id;
                $uibModalInstance.dismiss();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }
}

export default ClubCourtsPolicyController;
